import { render, staticRenderFns } from "./warehouseForPos.vue?vue&type=template&id=a2bac7bc&scoped=true"
import script from "./warehouseForPos.vue?vue&type=script&lang=js"
export * from "./warehouseForPos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bac7bc",
  null
  
)

export default component.exports